import { render, staticRenderFns } from "./chapterincome.vue?vue&type=template&id=2493c110&scoped=true&"
import script from "./chapterincome.vue?vue&type=script&lang=js&"
export * from "./chapterincome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2493c110",
  null
  
)

export default component.exports